/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponseData = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/**
 * Standard error response object
 */
export class PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponseData;

  constructor(
    err: PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse";
  }
}

/** @internal */
export const PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse$inboundSchema:
  z.ZodType<
    PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse(v);
    });

/** @internal */
export type PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse$Outbound = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/** @internal */
export const PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse$outboundSchema:
  z.ZodType<
    PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse$Outbound,
    z.ZodTypeDef,
    PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse
  > = z.instanceof(PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse)
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse$ {
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse$inboundSchema;
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse$outboundSchema;
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse$Outbound` instead. */
  export type Outbound =
    PutApiLeadScraperMicroserviceApiV1WebhooksErrorResponse$Outbound;
}
